import React, { Component } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import { Message, Icon } from 'semantic-ui-react';
import withFullScreenLoader from '../../UtilityComponents/withFullScreenLoading/index';
import HospitalCard from './Cards/HospitalCard';
import getFilteredHospitals from '../../../functions/getFilteredHospitals';

export class MapContainer extends Component {
  state = {};

  componentDidMount = () => {
    const { center, changeMapCenter } = this.props;
    changeMapCenter(center);
  }

  onMarkerClick = (props, marker) => this.setState({
    selectedPlace: props,
    activeMarker: marker,
    showingInfoWindow: true,
  });

  onMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  render() {
    const {
      location: {
        lat: currentLat = 0,
        lng: currentLng = 0,
      },
      center,
      filterValue,
    } = this.props;
    const {
      activeMarker,
      showingInfoWindow,
      selectedPlace: {
        hospital,
      } = {},
    } = this.state;
    const hospitals = getFilteredHospitals(filterValue, { lat: currentLat, lng: currentLng });
    return (
      <Map
        className="Hospitals__Maps"
        google={this.props.google}
        zoom={this.props.zoom || 14}
        initialCenter={{
          lng: 5.838042,
          lat: -55.184344,
        }}
        center={{
          lat: center ? center.lat : 5.838042,
          lng: center ? center.lng : -55.184344,
        }}
        onClick={this.onMapClicked}
      >
        <Marker
          onClick={this.onMarkerClick}
          name="Current location"
          position={{
            lat: currentLat,
            lng: currentLng,
          }}
          icon={{
            url: require('../../../assets/images/markers/yellowMarker.png'),
          }}
        />
        {hospitals.map((item) => {
          const { location: { lat, lng }, id } = item;
          return (
            <Marker
              key={id}
              onClick={this.onMarkerClick}
              hospital={item}
              position={{
                lat,
                lng,
              }}
              icon={{
                url: require(`../../../assets/images/markers/redMarker_${id}.png`),
              }}
            />
          );
        })}
        {hospital && (
          <InfoWindow
            marker={activeMarker}
            visible={showingInfoWindow}
          >
            <HospitalCard hospital={hospital} hasButtton />
          </InfoWindow>
        )
        }
      </Map>
    );
  }
}

const LoadingContainer = () => (
  <Message icon>
    <Icon name="circle notched" loading />
    <Message.Content>
      <Message.Header>Rendering map</Message.Header>
      We zijn de verschillende locaties op de map aan het tekenen
    </Message.Content>
  </Message>
);

export default withFullScreenLoader(GoogleApiWrapper({
  apiKey: ('AIzaSyAS2RwTDu9U-YcxBUrDecScC36r6KQkU3g'),
  LoadingContainer,
})(MapContainer), { noPlaceholder: true });



// WEBPACK FOOTER //
// ./src/components/Hospitals/SubComponents/HospitalMap.js